import s from './Umschalter.module.scss'

export interface UmschalterOption<T extends string> {
  wert: T
  text: string
}

/**
 * Ein Umschalter zwischen wenigen Sichten: „Liste | Nach Betrifft",
 * „Alle | Nur Neues".
 *
 * KEIN TAB: Reiter wechseln den Inhalt einer Karte, dieser Schalter wechselt
 * die Darstellung derselben Daten. Die gewählte Sicht steht als dunkle Fläche,
 * die anderen als Text — so sieht man auf einen Blick, was gerade gilt.
 */
export function Umschalter<T extends string>({ optionen, wert, onChange, label }: {
  optionen: UmschalterOption<T>[]
  wert: T
  onChange: (wert: T) => void
  /** Für Vorleseprogramme: wozu der Schalter dient. */
  label: string
}) {
  return (
    <div className={s.gruppe} role="group" aria-label={label}>
      {optionen.map((option) => (
        <button key={option.wert} type="button"
                className={s.knopf}
                aria-pressed={option.wert === wert}
                onClick={() => onChange(option.wert)}>
          {option.text}
        </button>
      ))}
    </div>
  )
}
